import { useEffect, useState } from 'react';
import { useUserFlags } from './useUserFlags';

const STORAGE_KEY = 'tc_full_access';
const QUERY_PARAM = 'ta'; // ?ta= grants full tipster access for this browser tab

function checkFullAccess(): boolean {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has(QUERY_PARAM)) {
    sessionStorage.setItem(STORAGE_KEY, 'true');
  }
  return sessionStorage.getItem(STORAGE_KEY) === 'true';
}

export function useAssistantMode(): { isAssistantMode: boolean; isLoading: boolean } {
  const { flags, isLoading } = useUserFlags();

  // Default to hidden until flags load, unless full access is already granted.
  // This prevents a flash of restricted content appearing before being hidden.
  const [isAssistantMode, setIsAssistantMode] = useState<boolean>(!checkFullAccess());

  useEffect(() => {
    const hasFullAccess = checkFullAccess();
    const flagEnabled = flags.some(
      (f) => f.flag === 'enable_assistant_mode' && f.enabled,
    );
    setIsAssistantMode(flagEnabled && !hasFullAccess);
  }, [flags]);

  return { isAssistantMode, isLoading };
}
